<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title pull-left" id="my-modal-title">
      {{ "APPEAL_APU_TITLE" | globalTranslate }}
    </h3>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    @if (!medicalAppealsSwitch) {
    <div>
      <p>
        {{ "APPEAL_APU_DESC" | globalTranslate
        }}<span style="color: #174a7c">1-800-878-3192.</span>
      </p>
      <br />
      <p>
        {{ "APPEAL_APU_INFO" | globalTranslate
        }}<a
          href="https://www.tn.gov/tenncare/members-applicants/how-to-file-a-medical-appeal.html"
          target="_blank"
          rel="noopener noreferrer"
          title=""
          style="color: #174a7c"
          ><strong>{{ "APPEAL_APU_CLK_LINK" | globalTranslate }}</strong></a
        >
      </p>
      <br />
    </div>
    } @if (medicalAppealsSwitch) {
    <div>
      <p
        class="sub_text"
        [innerHTML]="'MEDICAL_APPEAL_POPUP_TEXT_01' | globalTranslate"
      ></p>
      <p class="section-info">
        {{ "YOU_HAVE_RIGHT_TO_APPEAL_IF" | globalTranslate }}
      </p>
      <ul class="appeal-reasons">
        <li>{{ "MEDICAL_APPEAL_POPUP_TEXT_02" | globalTranslate }}</li>
        <li>{{ "MEDICAL_APPEAL_POPUP_TEXT_03" | globalTranslate }}</li>
        <li>{{ "MEDICAL_APPEAL_POPUP_TEXT_04" | globalTranslate }}</li>
        <li>{{ "MEDICAL_APPEAL_POPUP_TEXT_05" | globalTranslate }}</li>
        <li>{{ "MEDICAL_APPEAL_POPUP_TEXT_06" | globalTranslate }}</li>
      </ul>
      <p class="static_text">
        {{ "MEDICAL_APPEAL_POPUP_TEXT_07" | globalTranslate }}
      </p>
    </div>
    }
    <p [innerHTML]="'APPEAL_APU_CONTINUE' | globalTranslate"></p>
  </div>
  <div class="modal-footer action-container">
    <!-- [ngClass]="{'action-container':translatedLang === 'sp', 'action-container':translatedLang !== 'sp'}" -->
    @if (medicalAppealsSwitch) {
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog1"
        class="btn d-grid align-items-center btn-secondary"
        [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
        (click)="fileMedicalAppeal('MEDICAL_APPEAL')"
      >
        {{ "FILE_MEDICAL_APPEAL_BUTTON_TEXT" | globalTranslate }}
      </button>
    </div>
    } @if (medicalAppealsSwitch) {
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog1"
        class="btn d-grid align-items-center btn-link"
        [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
        (click)="onSelectReturnToAppeal()"
      >
        {{ "APPEAL_APU_BTN" | globalTranslate }}
      </button>
    </div>
    } @if (!medicalAppealsSwitch) {
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog1"
        class="btn d-grid align-items-center btn-secondary"
        [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
        (click)="onSelectReturnToAppeal()"
      >
        {{ "APPEAL_APU_BTN" | globalTranslate }}
      </button>
    </div>
    } @if (!medicalAppealsSwitch) {
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog1"
        class="btn d-grid align-items-center btn-link"
        [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
        (click)="onClosePopup()"
      >
        {{ "CLOSE" | globalTranslate }}
      </button>
    </div>
    }
  </div>
</div>
